export interface ResolutionDetail {
  id: number;
  name: string;
  resolutionTypeId: number;
}

export interface ResolutionType {
  id: number;
  name: string;
  details: ResolutionDetail[];
}

export const RESOLUTION_TYPES: ResolutionType[] = [
  { id: 21, name: 'credit', details: [] },
  {
    id: 3,
    name: 'facilitair',
    details: [
      { id: 78, name: 'algemeen', resolutionTypeId: 3 },
      { id: 71, name: 'bezorgen of ophalen huur', resolutionTypeId: 3 },
      { id: 21, name: 'onderdelen bestellen inkoop', resolutionTypeId: 3 },
      { id: 20, name: 'opladen objecten ook Biezenwade', resolutionTypeId: 3 },
    ],
  },
  {
    id: 6,
    name: 'inspectie',
    details: [
      { id: 43, name: 'aankoop', resolutionTypeId: 6 },
      { id: 64, name: 'schade', resolutionTypeId: 6 },
      { id: 41, name: 'werking', resolutionTypeId: 6 },
    ],
  },
  { id: 4, name: 'onderhoud', details: [] },
  { id: 20, name: 'reparatie', details: [] },
  { id: 2, name: 'retourhuur', details: [] },
  {
    id: 5,
    name: 'schade',
    details: [
      { id: 65, name: 'inspectie', resolutionTypeId: 5 },
      { id: 66, name: 'melding', resolutionTypeId: 5 },
      { id: 67, name: 'reparatie', resolutionTypeId: 5 },
    ],
  },
  {
    id: 1,
    name: 'storing',
    details: [
      { id: 55, name: 'band lucht', resolutionTypeId: 1 },
      { id: 56, name: 'band massief', resolutionTypeId: 1 },
      { id: 3, name: 'band vol rubber', resolutionTypeId: 1 },
      { id: 5, name: 'batterij laad niet', resolutionTypeId: 1 },
      { id: 4, name: 'batterij leeg', resolutionTypeId: 1 },
      { id: 11, name: 'doet niets', resolutionTypeId: 1 },
      { id: 8, name: 'gebroken distributieriem', resolutionTypeId: 1 },
      { id: 12, name: 'heft wel rijdt niet', resolutionTypeId: 1 },
      { id: 10, name: 'koelsysteem overtemperatuur', resolutionTypeId: 1 },
      { id: 77, name: 'lekkage gas', resolutionTypeId: 1 },
      { id: 9, name: 'lekkage koelsysteem', resolutionTypeId: 1 },
      { id: 1, name: 'lekkage olie', resolutionTypeId: 1 },
      { id: 73, name: 'mast slang/ketting', resolutionTypeId: 1 },
      { id: 63, name: 'remt niet', resolutionTypeId: 1 },
      { id: 70, name: 'rijdt langzaam', resolutionTypeId: 1 },
      { id: 13, name: 'rijdt wel heft niet', resolutionTypeId: 1 },
      { id: 6, name: 'start niet', resolutionTypeId: 1 },
      { id: 7, name: 'start niet draait wel', resolutionTypeId: 1 },
      { id: 14, name: 'stuurt niet', resolutionTypeId: 1 },
      { id: 51, name: 'verlichting dashboard defect', resolutionTypeId: 1 },
      { id: 53, name: 'verlichting RAW defect', resolutionTypeId: 1 },
      { id: 54, name: 'verlichting rem defect', resolutionTypeId: 1 },
      { id: 52, name: 'verlichting werklampen defect', resolutionTypeId: 1 },
      { id: 2, name: 'vork gebroken', resolutionTypeId: 1 },
      { id: 15, name: 'vork krom', resolutionTypeId: 1 },
      { id: 17, name: 'voorzetapparaat lekt', resolutionTypeId: 1 },
      { id: 58, name: 'voorzetapparaat monteren', resolutionTypeId: 1 },
      { id: 16, name: 'voorzetapparaat storing', resolutionTypeId: 1 },
      { id: 76, name: 'vreemd geluid', resolutionTypeId: 1 },
    ],
  },
  {
    id: 19,
    name: 'verkoop',
    details: [
      { id: 72, name: 'aflever gereedmaken', resolutionTypeId: 19 },
      { id: 62, name: 'object', resolutionTypeId: 19 },
      { id: 61, name: 'onderdeel', resolutionTypeId: 19 },
    ],
  },
];
